import React from 'react';
import { Footer } from 'react-materialize';
import './Footer.css';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
const photo = require('../../assets/images/logo-small-inv-t-greybg.png');

const footer = (props) => {
    // console.log("IN FOOTER WITH UID", props.uid);
    return (
            <Footer
                    copyrights="&copy; 2018-2026 All rights reserved"
                    className="Footer"
                    links={
                        <ul>
                            <li>
                                <Link to="/all-articles" className="grey-text text-lighten-3">All lessons</Link>
                            </li>
                            <li>
                                {/* Reels live on the content app — plain anchor (full page load)
                                    so Firebase Hosting routes /tips there; a router Link would
                                    404 inside the SPA. */}
                                <a href="/tips" className="grey-text text-lighten-3">Reels</a>
                            </li>
                            <li>
                                <Link to="/about" className="grey-text text-lighten-3">About Paul</Link>
                            </li>
                            <li>
                                <Link to="/contact" className="grey-text text-lighten-3">Contact Us</Link>
                            </li>
                            <li>
                                <Link to="/app" className="grey-text text-lighten-3">Get the app</Link>
                            </li>
                            <li>
                                <Link to="/privacy" className="grey-text text-lighten-3">Privacy Policy</Link>
                            </li>
                            {/*<li><a className="grey-text text-lighten-3" href="#!">Link 2</a></li>*/}
                            {/*<li><a className="grey-text text-lighten-3" href="#!">Link 3</a></li>*/}
                            {/*<li><a className="grey-text text-lighten-3" href="#!">Link 4</a></li>*/}
                        </ul>

                    }

            >
                <h5 className="white-text">
                    <img className="Footer-logo" src={photo} alt="Bridge Champions" />
                </h5>
                <p className="Footer-contactText">
                    Contact:{" "}
                    <a className="Footer-emailLink" href="mailto:team@bridgechampions.com">
                        team@bridgechampions.com
                    </a>
                </p>
            </Footer>
        );
}
export default connect(
    ({ auth }) => ({ uid: auth.uid }),
    null,
)(footer);

